import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About Us',
      services: 'Services',
      reviews: 'Reviews',
      gallery: 'Gallery',
      contact: 'Contact',
      bookNow: 'Book Now',
    },
    // Hero
    hero: {
      tagline: 'Where Beauty Meets Elegance',
      subtitle: 'Experience luxury beauty services in the heart of Dammam',
      bookAppointment: 'Book Appointment',
      callNow: 'Call Now',
      rating: 'Google Rating',
      reviews: 'reviews',
    },
    // About
    about: {
      title: 'About Sirena',
      subtitle: 'Your Premier Beauty Destination',
      description1: 'Sirena Beauty Salon is a modern women\'s beauty salon located in the prestigious Al Jawhara district of Dammam. We combine advanced techniques with expert hands to deliver exceptional beauty services.',
      description2: 'Our salon is committed to providing a clean, professional, and welcoming atmosphere where every client feels special. With our stylish interior and attention to detail, we ensure a truly luxurious experience.',
      description3: 'Whether you\'re looking for a simple hair styling or a complete makeover, our skilled team is dedicated to making you look and feel your best.',
      years: 'Years of Excellence',
      clients: 'Happy Clients',
      experts: 'Expert Stylists',
    },
    // Services
    services: {
      title: 'Our Services',
      subtitle: 'Premium Beauty Treatments',
      hairStyling: 'Hair Styling',
      hairStylingDesc: 'Professional cuts, styling, and color treatments to transform your look',
      hairWashing: 'Hair Washing & Conditioning',
      hairWashingDesc: 'Deep cleansing and nourishing treatments for healthy hair',
      hairTreatment: 'Hair Treatments',
      hairTreatmentDesc: 'Specialized treatments including keratin, protein, and repair therapies',
      professionalStyling: 'Professional Styling',
      professionalStylingDesc: 'Special occasion styling for weddings, parties, and events',
      makeup: 'Beauty & Makeup',
      makeupDesc: 'Expert makeup application for any occasion',
      nails: 'Nail Care',
      nailsDesc: 'Manicure, pedicure, and nail art services',
      facial: 'Facial Treatments',
      facialDesc: 'Rejuvenating facial treatments for glowing skin',
      spa: 'Spa & Relaxation',
      spaDesc: 'Relaxing spa services for mind and body wellness',
    },
    // Reviews
    reviews: {
      title: 'What Our Clients Say',
      subtitle: 'Customer Testimonials',
    },
    // Gallery
    gallery: {
      title: 'Our Gallery',
      subtitle: 'See Our Work',
    },
    // Contact
    contact: {
      title: 'Get In Touch',
      subtitle: 'Visit Us or Book an Appointment',
      address: 'Address',
      addressValue: 'Al Jawhara District, Dammam 32422, Saudi Arabia',
      phone: 'Phone',
      hours: 'Opening Hours',
      hoursValue: 'Every Day: 1 PM - 10 PM',
      closed: '',
      whatsapp: 'WhatsApp Us',
    },
    // Booking
    booking: {
      title: 'Book Your Appointment',
      selectService: 'Select Service',
      selectDate: 'Select Date',
      selectTime: 'Select Time',
      yourDetails: 'Your Details',
      name: 'Full Name',
      phone: 'Phone Number',
      email: 'Email (Optional)',
      notes: 'Additional Notes (Optional)',
      confirm: 'Confirm Booking',
      success: 'Appointment Booked!',
      successMessage: 'We will contact you shortly to confirm your appointment.',
      close: 'Close',
      step: 'Step',
      of: 'of',
      next: 'Next',
      back: 'Back',
      slotUnavailable: 'This slot is not available',
      noSlotsAvailable: 'No slots available for this date',
      mondayClosed: 'We are closed on Mondays',
    },
    // Footer
    footer: {
      rights: 'All Rights Reserved',
      tagline: 'Where Beauty Meets Elegance',
    },
  },
  ar: {
    // Navigation
    nav: {
      home: 'الرئيسية',
      about: 'من نحن',
      services: 'خدماتنا',
      reviews: 'آراء العملاء',
      gallery: 'معرض الصور',
      contact: 'اتصل بنا',
      bookNow: 'احجز الآن',
    },
    // Hero
    hero: {
      tagline: 'حيث يلتقي الجمال بالأناقة',
      subtitle: 'استمتعي بخدمات التجميل الفاخرة في قلب الدمام',
      bookAppointment: 'احجز موعد',
      callNow: 'اتصل الآن',
      rating: 'تقييم جوجل',
      reviews: 'تقييم',
    },
    // About
    about: {
      title: 'عن سيرينا',
      subtitle: 'وجهتك المميزة للجمال',
      description1: 'صالون سيرينا للتجميل هو صالون نسائي عصري يقع في حي الجوهرة المرموق بالدمام. نجمع بين التقنيات المتقدمة والأيدي الخبيرة لتقديم خدمات تجميل استثنائية.',
      description2: 'يلتزم صالوننا بتوفير جو نظيف واحترافي ومرحب حيث تشعر كل عميلة بأنها مميزة. مع تصميمنا الداخلي الأنيق واهتمامنا بالتفاصيل، نضمن تجربة فاخرة حقيقية.',
      description3: 'سواء كنتِ تبحثين عن تصفيف شعر بسيط أو مظهر كامل جديد، فإن فريقنا الماهر مكرس لجعلك تبدين وتشعرين بأفضل حالاتك.',
      years: 'سنوات من التميز',
      clients: 'عميلات سعيدات',
      experts: 'خبيرات تجميل',
    },
    // Services
    services: {
      title: 'خدماتنا',
      subtitle: 'علاجات تجميل فاخرة',
      hairStyling: 'تصفيف الشعر',
      hairStylingDesc: 'قص وتصفيف وصبغ احترافي لتحويل إطلالتك',
      hairWashing: 'غسيل وترطيب الشعر',
      hairWashingDesc: 'علاجات تنظيف عميق وتغذية لشعر صحي',
      hairTreatment: 'علاجات الشعر',
      hairTreatmentDesc: 'علاجات متخصصة تشمل الكيراتين والبروتين وعلاجات الإصلاح',
      professionalStyling: 'تصفيف احترافي',
      professionalStylingDesc: 'تصفيف للمناسبات الخاصة كالأعراس والحفلات',
      makeup: 'المكياج والتجميل',
      makeupDesc: 'مكياج احترافي لجميع المناسبات',
      nails: 'العناية بالأظافر',
      nailsDesc: 'مناكير وباديكير وفن الأظافر',
      facial: 'علاجات الوجه',
      facialDesc: 'علاجات وجه منعشة لبشرة متوهجة',
      spa: 'سبا واسترخاء',
      spaDesc: 'خدمات سبا مريحة لصحة الجسم والعقل',
    },
    // Reviews
    reviews: {
      title: 'ماذا تقول عميلاتنا',
      subtitle: 'شهادات العملاء',
    },
    // Gallery
    gallery: {
      title: 'معرض الصور',
      subtitle: 'شاهدي أعمالنا',
    },
    // Contact
    contact: {
      title: 'تواصلي معنا',
      subtitle: 'زورينا أو احجزي موعداً',
      address: 'العنوان',
      addressValue: 'حي الجوهرة، الدمام 32422، المملكة العربية السعودية',
      phone: 'الهاتف',
      hours: 'ساعات العمل',
      hoursValue: 'كل يوم: 1 ظهراً - 10 مساءً',
      closed: '',
      whatsapp: 'راسلينا واتساب',
    },
    // Booking
    booking: {
      title: 'احجزي موعدك',
      selectService: 'اختاري الخدمة',
      selectDate: 'اختاري التاريخ',
      selectTime: 'اختاري الوقت',
      yourDetails: 'بياناتك',
      name: 'الاسم الكامل',
      phone: 'رقم الهاتف',
      email: 'البريد الإلكتروني (اختياري)',
      notes: 'ملاحظات إضافية (اختياري)',
      confirm: 'تأكيد الحجز',
      success: 'تم الحجز بنجاح!',
      successMessage: 'سنتواصل معك قريباً لتأكيد موعدك.',
      close: 'إغلاق',
      step: 'الخطوة',
      of: 'من',
      next: 'التالي',
      back: 'رجوع',
      slotUnavailable: 'هذا الوقت غير متاح',
      noSlotsAvailable: 'لا توجد مواعيد متاحة لهذا اليوم',
      mondayClosed: 'نحن مغلقون يوم الاثنين',
    },
    // Footer
    footer: {
      rights: 'جميع الحقوق محفوظة',
      tagline: 'حيث يلتقي الجمال بالأناقة',
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('ar'); // Default to Arabic
  const [isRTL, setIsRTL] = useState(true);

  useEffect(() => {
    setIsRTL(language === 'ar');
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'ar' : 'en');
  };

  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, isRTL, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
